import { useQuery } from '@apollo/client';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { getTechniciansForUserListTemplate } from 'apollo/templates/user/query.graphql';
import { User } from 'models/user';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { MY_JOBS_TECHNICIAN_FILTER, NO_TECHNICIAN_FILTER } from './technician-filter.utils';

type TechnicianDropdownProps = {
    technicianId?: string | null;
    onTechnicianChange: (technicianId: string | null) => void;
    showMyJobsOption?: boolean;
};

export const TechnicianDropdown: FC<TechnicianDropdownProps> = ({
    technicianId,
    onTechnicianChange,
    showMyJobsOption,
}) => {
    const { t: translate } = useTranslation(['orders', 'common', 'workflow']);

    const { data: { technicians } = { technicians: [] } } = useQuery<{ technicians: User[] }>(
        getTechniciansForUserListTemplate,
        {
            variables: {
                filters: { active: true },
                limit: 0,
                offset: 0,
            },
        },
    );

    return (
        <FormControl fullWidth>
            <InputLabel id="technician-select-label">{translate('common:TECHNICIAN')}</InputLabel>
            <Select
                value={technicianId || ''}
                labelId="technician-select-label"
                label={translate('common:TECHNICIAN')}
                onChange={(event: SelectChangeEvent) => onTechnicianChange(event.target.value || null)}
            >
                <MenuItem value="">{translate('common:ALL')}</MenuItem>
                {showMyJobsOption && (
                    <MenuItem value={MY_JOBS_TECHNICIAN_FILTER}>{translate('orders:MY_JOBS')}</MenuItem>
                )}
                <MenuItem value={NO_TECHNICIAN_FILTER}>{translate('workflow:NO_TECHNICIAN')}</MenuItem>
                {technicians.map((technician) => (
                    <MenuItem key={technician._id} value={technician._id}>
                        {`${technician.name.firstName} ${technician.name.lastName}`}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};
